import {Fragment} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
function FormInputIcon({
                       label,
                       name,
                       errors,
                       type = "text",
                       required = false,
                       value,
                       defaultValue = "",
                       placeholder = "",
                       textarea = false,
                       maxLengthText = "max length 1000 character",
                       disabled = false,
                       showHeaderLabel = true,
                       icon,
                       validation = {},
                       isShowHideIcon = false,
                       showPassword = false,
                       onClickShowHide
                   }) {
    const InputTag = textarea ? "textarea" : "input";
    return (
        <Fragment>
            {
                showHeaderLabel && <span className="form-label">{label.replace("Assign", "")}</span>
            }
            <div className="form-icon-container">
                <div className="form-floating">
                    <InputTag
                        disabled={disabled}
                        type={type}
                        className={`form-control form-icon-input ${textarea ? "textarea-h-130" : ""}`}
                        {...validation}
                        {...(value !== undefined ? {value} : {defaultValue})}
                        placeholder={placeholder || label}
                    />
                    <label htmlFor={name} className="text-body-tertiary form-icon-label">
                        {label}{required && "(*)"}
                    </label>
                    <div className="d-flex justify-content-between">
                        <span>
                            {errors?.[name] && (
                                <span className="fs-9 fw-bold text-danger">
                                    {errors?.[name].message}
                                </span>
                            )}
                        </span>
                        <span className="fs-10 fw-bold">{maxLengthText}</span>
                    </div>
                </div>
                { icon && <FontAwesomeIcon className="form-icon fs-9 text-body" icon={icon} /> }
                {isShowHideIcon && !disabled && (
                    <button
                        type="button"
                        className="btn px-3 position-absolute top-0 end-0 fs-7 text-body-tertiary"
                        onClick={() => onClickShowHide((prev) => !prev)}
                        style={{top: "12px"}}
                    >
                        <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                            className="fs-10"
                            style={{ paddingBottom: "2px" }}
                        />
                    </button>
                )}
            </div>
        </Fragment>
    );
}

export default FormInputIcon;
